import React from 'react';
import { connect } from 'react-redux';
import Tether from 'react-tether';
import { Context } from '@leverege/plugin';
import RolloverModel from "./RolloverModel.js";
import { RolloverFactory } from "./Factory.js";
import Style from "../shared/Style.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  getOuterStyle,
  getInnerStyle,
  getAttachment
} = Style;
const CONSTRAINTS = [{
  to: 'window',
  attachment: 'together',
  pin: true
}];
function RolloverCard(props) {
  const {
    model,
    context,
    pointerPosition
  } = props;

  // Get Target Type(s)
  const types = Context.getTargetTypes(context);
  if (types == null || types.length === 0) {
    return null;
  }
  let type = 'object[]';
  if (types.length === 1) {
    type = Array.isArray(context.target) && context.target.length === 1 ? types[0] : `${types[0]}[]`;
  }

  // Get DetailModel for the Type(s)
  const typeModel = RolloverModel.getType(model, type);
  if (typeModel == null || typeModel.visible === false) {
    return null;
  }
  const atPointPlacement = RolloverModel.getPointPlacementForType(model, type);
  const placement = RolloverModel.getPlacementForType(model, type);
  const margin = typeModel.margin || model.margin || '16px';
  // If we are rendering at the point, use tether to place in a good spot
  if (atPointPlacement != null && pointerPosition) {
    const spot = {
      position: 'absolute',
      width: '64px',
      height: '64px',
      pointerEvents: 'none',
      display: 'hidden',
      top: `${pointerPosition.y - 32}px`,
      left: `${pointerPosition.x - 32}px`
    };
    return /*#__PURE__*/_jsx(Tether, {
      style: {
        pointerEvents: 'none'
      },
      attachment: getAttachment(atPointPlacement),
      offset: "0 0",
      constraints: CONSTRAINTS,
      renderTarget: ref => /*#__PURE__*/_jsx("div", {
        ref: ref,
        style: spot
      }),
      renderElement: ref => RolloverFactory.create(typeModel.details, {
        domRef: ref,
        context
      })
    });
  }
  if (placement === 'none') {
    return null;
  }
  // Otherwise, position it at the desirec screen position
  return /*#__PURE__*/_jsx("div", {
    style: getOuterStyle(placement, margin),
    children: /*#__PURE__*/_jsx("div", {
      style: getInnerStyle(placement, margin),
      children: RolloverFactory.create(typeModel.details, {
        context
      })
    })
  });
}
const EMPTY = {};
export default connect((state, props) => {
  const model = props.model || EMPTY; // get from Rsrc if model not supplied

  return {
    model
  };
})(RolloverCard);